import { useMemo } from 'react';
import { useParticipantsCategories } from './useParticipantsCategories';


export function useNetworkareaFilterCategory(eventId) {
    const categories = useParticipantsCategories(eventId);
    return useMemo(() => categories.find(c => c.networkarea_filter_category), [categories]);
}
